var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",staticStyle:{"padding-top":"164px"}},[_c('div',{staticClass:"text-center text-h4"},[_c('p',{staticClass:"fontFamlily"},[_vm._v(" The server is under maintenance... ")]),_c('v-icon',{staticClass:"achtgreen--text",attrs:{"size":"48"}},[_vm._v("mdi-emoticon-sad-outline")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }